export const albumTimGinny = {
  albumTitle: "Tim & Ginny",
  albumDesc: "25 Auguest 2018 in Zoeterwoude, The Netherlands",
  photos: [
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/3f6fc675725251.5c549dd48c7dc.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/40682575725251.5c802551cc113.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/1d9cbf75725251.5c802551d653f.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/abee2175725251.5c802551c9649.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/2ce50575725251.5c802551cbe27.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/ba8edc75725251.5c802551cc3f8.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/e8910f75725251.5c802551c8f9b.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/103dc175725251.5c802551cabcb.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/e3656c75725251.5c802551c91ff.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/7e5bbf75725251.5c802551c8920.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/fde33275725251.5c802551c9af8.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/123f7f75725251.5c802551d0bc1.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/b664a575725251.5c802551cd62f.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/d37b3175725251.5c802551ca797.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/35818e75725251.5c802551cdd63.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/f9675b75725251.5c802551cfc4e.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/ed240b75725251.5c802551ca33e.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/8a103975725251.5c802551d1783.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/328a4675725251.5c802551ce526.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/76629675725251.5c802551d1ebf.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/0663f075725251.5c802551d0ec5.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/f17ccc75725251.5c802551ce884.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/ff9ccb75725251.5c802551d2eb3.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/aec6d175725251.5c802551d0766.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/d486c375725251.5c802551d02fa.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/1a1bd175725251.5c802551cf7f4.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/bfe98a75725251.5c802551d1a41.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/7fcda275725251.5c802551ceb2c.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/1e695375725251.5c802551d428e.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/3d014975725251.5c802551d1332.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/1bfef275725251.5c802551d2266.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/da337075725251.5c802551d39d0.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/3a729575725251.5c802551d26c1.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/4b24ae75725251.5c802551d59d3.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/d5c77975725251.5c802551d7c96.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/efe38f75725251.5c802551d536c.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/89481075725251.5c802551d4723.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/4bdc1575725251.5c802551d86c9.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/c65d0475725251.5c802551d831f.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/52e36d75725251.5c802551d8dfd.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/bb0b1f75725251.5c802551d68c7.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/86d83975725251.5c802551d774f.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/51214675725251.5c802551d73c3.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/7e9eae75725251.5c802551d566c.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/116d5c75725251.5c802551d60e9.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/f2c83275725251.5c802551d95d6.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/8dec7e75725251.5c802551da9aa.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/2689fd75725251.5c802551d9a3b.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/df56d075725251.5c802551d9ec1.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/5bc43275725251.5c802551dcaee.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/cec1d975725251.5c802551dcf18.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/6ec6f075725251.5c802551dd8cb.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/4fc88f75725251.5c802551de340.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/ede49075725251.5c802551dc8c0.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/496a7275725251.5c802551deb96.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/34240475725251.5c802551dfd5c.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/max_3840/d13bf875725251.5c54659ef126d.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/b0cfd675725251.5c54659ef1d59.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/665ad575725251.5c54659ef0cae.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/67211875725251.5c54659ef0ff3.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/c74d4975725251.5c54659ef18ae.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/5382ce75725251.5c549dd48c37d.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/4c2e7775725251.5c549dd48ca7e.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/5fac4875725251.5c549dd48d35e.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/a1ad0175725251.5c549dd48d028.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/3bc1bd75725251.5c802551dcd0e.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/1a350a75725251.5c802551db460.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/c0dd4075725251.5c802551dff8c.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/ee3a4575725251.5c802551dfaa1.jpg",
    },
    {
      src: "https://mir-s3-cdn-cf.behance.net/project_modules/2800/af022575725251.5c802551e03e6.jpg",
    },
    {
      src: "https://cdnjs.cloudflare.com/ajax/libs/baguettebox.js/1.8.1/baguetteBox.min",
    },
  ],
};
